// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__RrTua","copyright":"styles_copyright__AtDhH","navIconLink":"styles_navIconLink__qc1F6","navIconLinkMobile":"styles_navIconLinkMobile__rZWSG"};